import { Dispatch } from "react";
import { PatientFilterState } from "src/pages/actionDashboard/types";

import {
  QueryParamsState,
  QueryStateActionType,
} from "src/pages/dashboard/types";

export type StatsSearchProps = {
  start_date: string;
  end_date: string;
  practice_id: string;
  global_doctor_id: string;
  case_id: string;
  id?: string;
  role?: string;
  filter_type?: string;
  period?: string;
};

export type StatisticsProps = {
  defaultQueryParams?: PatientFilterState;
  doctorDropdown: { id: number; name: string }[];
  practiceDropdown: { id: number; name: string }[];
  updateQueryParams: (
    queryParams: PatientFilterState,
    isReset: boolean
  ) => void;
  region_dropdown:string[];
  territory_dropdown:string[];
  state_dropdown:string[];
  activeTab:string;
};

export type SocDoctorResponseType = {
  code: number;
  message: string;
  data: { id: string; name: string }[];
};

export type CaseFilterProps = {
  dropdownData: {
    label: string;
    value: string | boolean;
  }[];
  inputPlaceholder: string;
  state: QueryParamsState;
  dispatch: Dispatch<QueryStateActionType>;
  handleSearchWithQueryParam: (updatedState?: QueryParamsState) => void;
  onClearButtonClicked: () => void;
};
export const DRUG_NAME = [
  {
    value: "",
    label: "All Products",
  },
  {
    value: "iovera°",
    label: "iovera°",
  },
  {
    value: "zilretta",
    label: "ZILRETTA",
  },
];
